import t, { PureComponent as e } from "react";
import o from "prop-types";

function r(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function n(t, e) {
  for (var o = 0; o < e.length; o++) {
    var r = e[o];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}

function s(t, e, o) {
  return e && n(t.prototype, e), o && n(t, o), t;
}

function i(t, e, o) {
  return e in t ? Object.defineProperty(t, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = o, t;
}

function a() {
  return (a = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var o = arguments[e];

      for (var r in o) {
        Object.prototype.hasOwnProperty.call(o, r) && (t[r] = o[r]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function l(t, e) {
  var o = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), o.push.apply(o, r);
  }

  return o;
}

function c(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && p(t, e);
}

function _(t) {
  return (_ = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function p(t, e) {
  return (p = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function w(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function d(t, e) {
  return !e || "object" != typeof e && "function" != typeof e ? w(t) : e;
}

function f(t) {
  var e = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;

    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
    } catch (t) {
      return !1;
    }
  }();

  return function () {
    var o,
        r = _(t);

    if (e) {
      var n = _(this).constructor;

      o = Reflect.construct(r, arguments, n);
    } else o = r.apply(this, arguments);

    return d(this, o);
  };
}

var y = {
  return: 13,
  arrowLeft: 37,
  arrowUp: 38,
  arrowRight: 39,
  arrowDown: 40,
  space: 32
};
y.keyCodes = Object.keys(y).reduce(function (t, e) {
  return t[y[e]] = e, t;
}, {});
var u = {
  "faq-row-wrapper": "styles_faq-row-wrapper__3vA1D",
  "faq-row": "styles_faq-row__2YF3c",
  "row-body": "styles_row-body__1NvUo",
  "row-title": "styles_row-title__1YiiY",
  "no-tabfocus": "styles_no-tabfocus__1HmyD",
  "row-title-text": "styles_row-title-text__1MuhU",
  "icon-wrapper": "styles_icon-wrapper__2cftw",
  closed: "styles_closed__39w54",
  "row-content": "styles_row-content__QOGZd",
  animate: "styles_animate__3ecdr",
  static: "styles_static__3chYW",
  expanded: "styles_expanded__3elPy",
  expanding: "styles_expanding__2OAFB",
  "row-content-text": "styles_row-content-text__2sgAB"
};
!function (t, e) {
  void 0 === e && (e = {});
  var o = e.insertAt;

  if (t && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        n = document.createElement("style");
    n.type = "text/css", "top" === o && r.firstChild ? r.insertBefore(n, r.firstChild) : r.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
  }
}(".styles_faq-row-wrapper__3vA1D {\n  background-color: var(--faq-bg-color, white); }\n  .styles_faq-row-wrapper__3vA1D h2 {\n    margin: 0;\n    color: var(--title-text-color, black);\n    font-size: var(--title-text-size, 30px); }\n  .styles_faq-row-wrapper__3vA1D .styles_faq-row__2YF3c {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 0;\n    border-bottom: 1px solid #ccc; }\n  .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c {\n    flex-direction: column;\n    position: relative; }\n    .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY {\n      padding: 10px 0;\n      display: flex;\n      justify-content: space-between;\n      color: var(--row-title-color, black);\n      font-size: var(--row-title-text-size, large);\n      cursor: pointer;\n      align-items: center; }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_no-tabfocus__1HmyD {\n        outline: none; }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY .styles_row-title-text__1MuhU {\n        padding-right: 3em; }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY .styles_icon-wrapper__2cftw {\n        max-width: 25px;\n        max-height: 25px;\n        margin: 0;\n        padding: 0;\n        color: var(--arrow-color, black);\n        transform: rotate(0deg);\n        transition: transform var(--transition-duration, 0.3s);\n        position: absolute;\n        top: 13px;\n        right: 12px; }\n        .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY .styles_icon-wrapper__2cftw svg {\n          width: 100%;\n          height: 100%; }\n        .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY .styles_icon-wrapper__2cftw svg {\n          fill: var(--arrow-color, black); }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_closed__39w54 + .styles_row-content__QOGZd {\n        visibility: hidden; }\n        .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_closed__39w54 + .styles_row-content__QOGZd.styles_animate__3ecdr {\n          opacity: 0;\n          transition: height var(--transition-duration, 0.3s); }\n        .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_closed__39w54 + .styles_row-content__QOGZd.styles_static__3chYW {\n          display: none; }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_expanded__3elPy + .styles_row-content__QOGZd {\n        visibility: visible; }\n        .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_expanded__3elPy + .styles_row-content__QOGZd.styles_static__3chYW {\n          display: block; }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_expanded__3elPy .styles_icon-wrapper__2cftw {\n        transform: rotate(180deg); }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-title__1YiiY.styles_expanding__2OAFB .styles_icon-wrapper__2cftw {\n        transform: rotate(180deg); }\n    .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-content__QOGZd {\n      overflow: hidden;\n      transition: height var(--transition-duration, 0.3s);\n      transition-timing-function: var(--timing-function, ease); }\n      .styles_faq-row-wrapper__3vA1D .styles_row-body__1NvUo .styles_faq-row__2YF3c .styles_row-content__QOGZd .styles_row-content-text__2sgAB {\n        color: var(--row-content-color, black);\n        font-size: var(--row-content-text-size, medium);\n        padding: var(--row-content-padding-top, 0) var(--row-content-padding-right, 0) var(--row-content-padding-bottom, 0) var(--row-content-padding-left, 0); }\n");

var v = function (o) {
  c(_, e);
  var n = f(_);

  function _() {
    var e;
    r(this, _);

    for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++) {
      s[a] = arguments[a];
    }

    return i(w(e = n.call.apply(n, [this].concat(s))), "state", {
      isExpanded: !1,
      ref: t.createRef(),
      rowRef: t.createRef(),
      height: 0,
      rowClassName: "closed"
    }), i(w(e), "finishTransition", function () {
      var t = e.state.isExpanded;
      e.setState({
        rowClassName: t ? "expanded" : "closed"
      });
    }), i(w(e), "toggle", function (t) {
      e.setState(function () {
        return {
          isExpanded: t
        };
      });
    }), i(w(e), "expand", function () {
      e.setState(function (t) {
        return {
          isExpanded: !t.isExpanded
        };
      });
    }), i(w(e), "keyPress", function (t) {
      var o = t.keyCode ? t.keyCode : t.which;

      switch (y.keyCodes[o]) {
        case "space":
        case "return":
          t.preventDefault(), t.stopPropagation(), e.expand();
      }
    }), i(w(e), "setHeight", function () {
      var t = e.state,
          o = t.ref,
          r = t.isExpanded,
          n = o.current.scrollHeight;
      e.setState({
        height: r ? n : 0
      });
    }), e;
  }

  return s(_, [{
    key: "getSnapshotBeforeUpdate",
    value: function value(t, e) {
      var o = e.isExpanded,
          r = this.state.isExpanded,
          n = this.props.config,
          s = (n = void 0 === n ? {} : n).animate,
          i = void 0 === s || s;
      return r !== o ? {
        rowClassName: r ? i ? "expanding" : "expanded" : i ? "closing" : "closed"
      } : null;
    }
  }, {
    key: "componentDidUpdate",
    value: function value(t, e, o) {
      var r = this.props.config,
          n = (r = void 0 === r ? {} : r).animate,
          s = void 0 === n || n;
      null !== o && this.setState(function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var o = null != arguments[e] ? arguments[e] : {};
          e % 2 ? l(Object(o), !0).forEach(function (e) {
            i(t, e, o[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : l(Object(o)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
          });
        }

        return t;
      }({}, o), s ? this.setHeight : void 0);
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      var t = this,
          e = this.state.rowRef;

      if (this.props.getRowOptions) {
        var o = {
          expand: function expand() {
            t.toggle(!0);
          },
          close: function close() {
            t.toggle(!1);
          },
          scrollIntoView: function scrollIntoView(t) {
            t ? e.current.scrollIntoView(t) : e.current.scrollIntoView();
          }
        };
        this.props.getRowOptions(o);
      }
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          o = e.data,
          r = o.title,
          n = o.content,
          s = e.config,
          i = (s = void 0 === s ? {} : s).animate,
          l = void 0 === i || i,
          c = s.arrowIcon,
          _ = s.tabFocus,
          p = void 0 !== _ && _,
          w = this.state,
          d = w.isExpanded,
          f = w.ref,
          y = w.height,
          v = w.rowClassName,
          g = w.rowRef,
          h = {
        onClick: this.expand,
        role: "button",
        "aria-expanded": d,
        "aria-controls": "react-faq-rowcontent-".concat(this.props.rowid),
        onKeyPress: this.keyPress,
        onKeyDown: this.keyPress
      };
      p && (h.tabIndex = 0);
      var b = {
        role: "region",
        id: "react-faq-rowcontent-".concat(this.props.rowid),
        "aria-expanded": d,
        "aria-hidden": !d,
        onTransitionEnd: this.finishTransition
      };
      l && (b.style = {
        height: y
      });
      var m = ["row-title", v, u["row-title"], u[v], p ? "" : u["no-tabfocus"]].filter(Boolean).join(" "),
          x = c || t.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="36px" height="36px"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path d="M0 0h24v24H0V0z" fill="none"/></svg>'
        },
        className: "arrow-image ".concat(u["arrow-image"]),
        alt: "Expand arrow"
      }),
          q = [u["row-content"], "row-content", l ? u.animate : u.static].join(" "),
          O = [u["row-content-text"], "row-content-text"].join(" "),
          Y = n && "string" == typeof n ? t.createElement("div", {
        className: O,
        dangerouslySetInnerHTML: {
          __html: n
        }
      }) : t.createElement("div", {
        className: O
      }, n);
      return t.createElement("section", {
        className: "faq-row ".concat(u["faq-row"]),
        role: "listitem",
        ref: g
      }, t.createElement("div", a({
        className: m
      }, h), t.createElement("div", {
        className: "row-title-text ".concat(u["row-title-text"]),
        id: "react-faq-rowtitle-".concat(this.props.rowid)
      }, r), t.createElement("span", {
        className: "icon-wrapper ".concat(u["icon-wrapper"]),
        "aria-hidden": "true"
      }, x)), t.createElement("div", a({
        className: q
      }, b, {
        ref: f
      }), Y));
    }
  }]), _;
}();

i(v, "propTypes", {
  config: o.object,
  data: o.object,
  rowid: o.number,
  getRowOptions: o.func
});

var g = function (o) {
  c(a, e);
  var n = f(a);

  function a() {
    var t;
    r(this, a);

    for (var e = arguments.length, o = new Array(e), s = 0; s < e; s++) {
      o[s] = arguments[s];
    }

    return i(w(t = n.call.apply(n, [this].concat(o))), "state", {
      rowsOption: []
    }), t;
  }

  return s(a, [{
    key: "componentDidMount",
    value: function value() {
      this.props.getRowOptions && this.props.getRowOptions(this.state.rowsOption);
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
          o = this.props.data || {},
          r = o.title,
          n = o.rows,
          s = void 0 === n ? [] : n,
          i = this.props,
          a = i.styles,
          l = void 0 === a ? {} : a,
          c = i.config,
          _ = ((c = void 0 === c ? {} : c).animate, {
        "--faq-bg-color": l.bgColor,
        "--title-text-color": l.titleTextColor,
        "--title-text-size": l.titleTextSize,
        "--row-title-color": l.rowTitleColor,
        "--row-title-text-size": l.rowTitleTextSize,
        "--row-content-color": l.rowContentColor,
        "--row-content-text-size": l.rowContentTextSize,
        "--row-content-padding-top": l.rowContentPaddingTop,
        "--row-content-padding-bottom": l.rowContentPaddingBottom,
        "--row-content-padding-right": l.rowContentPaddingRight,
        "--row-content-padding-left": l.rowContentPaddingLeft,
        "--arrow-color": l.arrowColor,
        "--transition-duration": l.transitionDuration,
        "--timing-function": l.timingFunc
      }),
          p = "faq-row-wrapper ".concat(u["faq-row-wrapper"]),
          w = "faq-title ".concat(u["faq-row"]),
          d = "faq-body ".concat(u["row-body"]);

      return t.createElement("div", {
        className: p,
        style: _
      }, r ? t.createElement("section", {
        className: w
      }, t.createElement("h2", null, r)) : null, s.length ? t.createElement("section", {
        className: d,
        role: "list"
      }, s.map(function (o, r) {
        return t.createElement(v, {
          data: o,
          key: r,
          rowid: r + 1,
          config: e.props.config,
          getRowOptions: function getRowOptions(t) {
            return e.state.rowsOption[r] = t;
          }
        });
      })) : null);
    }
  }]), a;
}();

i(g, "propTypes", {
  data: o.object,
  styles: o.object,
  config: o.object,
  getRowOptions: o.func
});
export default g;